import { render, staticRenderFns } from "./file-upload-input.vue?vue&type=template&id=facf8918"
import script from "./file-upload-input.vue?vue&type=script&lang=js"
export * from "./file-upload-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('facf8918')) {
      api.createRecord('facf8918', component.options)
    } else {
      api.reload('facf8918', component.options)
    }
    module.hot.accept("./file-upload-input.vue?vue&type=template&id=facf8918", function () {
      api.rerender('facf8918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/file-upload-input.vue"
export default component.exports